var isDate = function isDate(value) {
  if (!value) return;
  var params = value.split("/");
  var year = parseInt(params[2], 10);
  var month = parseInt(params[1], 10);
  var day = parseInt(params[0], 10);
  var currentDate = new Date();
  var currentYear = currentDate.getFullYear();
  var currentDay = currentDate.getDate();
  var currentMonth = currentDate.getMonth() + 1;
  if (month > 12 || day > 31 || year > currentYear || year < 1900 || year >= currentYear && month > currentMonth || year >= currentYear && month === currentMonth && day > currentDay) {
    return false;
  }
  var reference = new Date(year, month - 1, day);
  var refYear = reference.getFullYear();
  var refDay = reference.getDate();
  var refMonth = reference.getMonth() + 1;
  if (refYear !== year || refMonth !== month || refDay !== day) {
    return false;
  }
  return true;
};
module.exports = isDate;